module.exports = __webpack_public_path__ + "static/media/developer.c3df4e53.jpg";